/**
 * XPEN-2400: Shared invoice date helpers for Billing Date -> Pay Date recalculation.
 */

/**
 * Returns the invoice due date computed from the billing date and supplier payment terms.
 * If the inputs are incomplete or invalid for this feature, returns null so callers can keep
 * the current DueDate unchanged.
 *
 * @param {string | null | undefined} invoiceDate - Billing date in YYYY-MM-DD format.
 * @param {number | null | undefined} paymentTerms - Supplier payment terms in calendar days.
 * @returns {string | null}
 */
export function computeInvoiceDueDate(invoiceDate, paymentTerms) {
  if (!invoiceDate || !Number.isInteger(paymentTerms)) {
    return null;
  }

  return new Date(new Date(invoiceDate).setDate(new Date(invoiceDate).getDate() + paymentTerms))
    .toISOString()
    .split('T')[0];
}
